import { ajax } from '@/api/ajax';
import type { ReverseVinListUsingPostApiResponse, VinReverseReq } from './type';

export const reverse = (data: VinReverseReq) => {
  return ajax<ReverseVinListUsingPostApiResponse>({
    method: 'post',
    data,
    url: '/api/xp-ass-common-cn-boot/portal/common/vin/reverse'
  });
};
